import script from "./PanelStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelStudio.vue?vue&type=script&setup=true&lang=js"

import "./PanelStudio.vue?vue&type=style&index=0&id=79ac0992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ac0992"]])

export default __exports__